/**
 * Normalizes a string by removing all whitespace and converting to lowercase.
 * This is used for comparing guesses in a case-insensitive and whitespace-insensitive manner.
 *
 * @param {string} str - The string to normalize
 * @returns {string} The normalized string
 *
 * @example
 * simplified("Hello World") // "helloworld"
 * simplified("NEW YORK") // "newyork"
 * simplified("  cat  ") // "cat"
 */
export const simplified = (str) => str.replace(/\s+/g, '').toLowerCase();
